import {
 ACCESS_TOKEN_KEY,
 REFRESH_TOKEN_KEY,
} from 'constants/common'
import {
 clearRedirectUri,
 isPublicPath,
} from 'helpers/authRedirect'
import * as authHelper from 'utils/helpers/authHelper'
import {persistToken} from 'utils/helper'

let isAuthFailureInProgress = false

export class SessionExpiredError extends Error {
 constructor() {
  super('SESSION_EXPIRED')
  this.name = 'SessionExpiredError'
 }
}

export const getIsAuthFailureInProgress = () =>
 isAuthFailureInProgress

export const clearSessionAndRedirect = () => {
 persistToken(ACCESS_TOKEN_KEY, '', -1)
 persistToken(REFRESH_TOKEN_KEY, '', -1)
 authHelper.removeAuth()
 clearRedirectUri()
 localStorage.removeItem('accessToken')
 localStorage.removeItem('refreshToken')
 localStorage.removeItem('accessExpiresIn')
 localStorage.removeItem('refreshExpiresIn')
 localStorage.removeItem('tabId')
 if (isPublicPath(window.location.pathname)) {
  isAuthFailureInProgress = false
  return
 }
 window.location.href = '/'
}

export const handleAuthFailure = () => {
 if (isAuthFailureInProgress) {
  return
 }
 isAuthFailureInProgress = true
 clearSessionAndRedirect()
}
